import { render, staticRenderFns } from "./InviteAccountModal.vue?vue&type=template&id=1085c4f0&"
import script from "./InviteAccountModal.vue?vue&type=script&lang=js&"
export * from "./InviteAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./InviteAccountModal.vue?vue&type=style&index=0&id=1085c4f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports